import { Fragment, MouseEventHandler, ReactNode } from 'react'
import cx from 'classnames'

import { Link, useMatch } from 'features/i18n/router'

export type BoxHeaderNav = {
  to?: string
  className?: string
  linkClass?: string
  onClick?: MouseEventHandler
  label?: ReactNode
  count?: string
  isActive?: boolean
  isBack?: boolean
  customElement?: ReactNode
  title?: string
}

const BoxHeaderNavItem = ({ nav, noMatch }) => {
  const Elm = nav.to ? Link : 'div'
  const match =
    !noMatch && !!nav.to && Boolean(useMatch(nav.to?.split('?')?.[0]))

  return (
    <li className={nav.className} title={nav.title}>
      {nav.customElement ? (
        nav.customElement
      ) : (
        <Elm
          {...(Elm === Link && { to: nav.to })}
          className={cx('Box__nav__a', {
            'Box__nav__a--back': nav.isBack,
            'Box__nav__a--active': match || nav.isActive,
            [nav.linkClass]: nav.linkClass,
          })}
          onClick={nav.onClick}
        >
          {nav.count && (
            <Fragment>
              <div className="Box__nav__a__dt">{nav.label}</div>
              <div className="Box__nav__a__dd">{nav.count}</div>
            </Fragment>
          )}
          {!nav.count && <>{nav.label}</>}
        </Elm>
      )}
    </li>
  )
}

const BoxHeader = ({
  nav,
  beforeNav,
  afterNav,
  headerClass,
  noMatch = false,
}: {
  nav: Array<BoxHeaderNav>
  beforeNav?: any
  afterNav?: any
  headerClass?: string
  noMatch?: boolean
}) => {
  return (
    <div className={cx('Box__header', headerClass)}>
      {beforeNav}
      <ul className="Box__nav">
        {nav.map((navItem, i) => {
          if (!navItem) return null
          return <BoxHeaderNavItem key={i} nav={navItem} noMatch={noMatch} />
        })}
      </ul>
      {afterNav}
    </div>
  )
}

export default BoxHeader
